import type { QueryFunction } from '@tanstack/react-query';
import {
  getUserCompanyLimit,
  updateUserCompanyLimits,
} from '@simplywallst/services';
import { withAuth } from '@/utilities/queries';
import { getAuthCookie } from '@utilities/cookies';

export const mutateCompanyViewKey = 'updateCompanyLimits';

type MutateResponse = Awaited<
  ReturnType<typeof updateUserCompanyLimits>
>['data'];

export const mutateCompanyViews: QueryFunction<
  MutateResponse | undefined,
  [string, string | undefined]
> = async (context) => {
  const { 1: companyId } = context.queryKey;
  if (typeof companyId === 'undefined') return undefined;
  const hasCookie = await getAuthCookie();
  if (typeof hasCookie === 'undefined') {
    return undefined;
  }
  const limits = await withAuth(updateUserCompanyLimits, companyId);
  return limits.data;
};

export const getQueryKey = (id: string) => ['USER_COMPANY_LIMITS', id] as const;
export async function queryCompanyViews() {
  const response = await withAuth(getUserCompanyLimit);
  return response.data;
}

export const getMutateCompanyViews = async (
  companyId: string | undefined
): Promise<MutateResponse | undefined> => {
  try {
    if (typeof companyId === 'undefined') return undefined;
    const hasCookie = await getAuthCookie();
    if (typeof hasCookie === 'undefined') {
      return undefined;
    }
    const limits = await withAuth(updateUserCompanyLimits, companyId);
    return limits.data;
  } catch (_err) {
    console.error(_err);
    return undefined;
  }
};
